export default __webpack_public_path__ + "static/media/Shell.3a401662.jpg";